import { render, staticRenderFns } from "./UseNotificationSet.vue?vue&type=template&id=0b2fcd45&"
import script from "./UseNotificationSet.vue?vue&type=script&lang=js&"
export * from "./UseNotificationSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports